import script from "./ProProxyUiFeaturesBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ProProxyUiFeaturesBox.vue?vue&type=script&setup=true&lang=js"

import "./ProProxyUiFeaturesBox.vue?vue&type=style&index=0&id=71eb37d8&scoped=true&lang=css"
import "./ProProxyUiFeaturesBox.vue?vue&type=style&index=1&id=71eb37d8&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71eb37d8"]])

export default __exports__